import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';

const STATUS_COLORS = {
    'Not Transferred': 'secondary',
    'Partially Transferred': 'warning',
    'Fully Transferred': 'success',
    'Over Transferred': 'danger',
    'Manually Marked as Completed': 'success'
};

function TransferStatusBadge({ status }) {
    const color = STATUS_COLORS[status] || 'secondary';
    return <Badge color={color}>{status}</Badge>;
}

TransferStatusBadge.propTypes = {
    status: PropTypes.string.isRequired
};

export { TransferStatusBadge };
